/**
 * Xero Trial Balance Report
 *
 * Combined trial balance + COA alignment report from Xero for all franchise partners.
 */
import BaseReportPage, { ColumnDef, ColumnGroup } from './BaseReportPage'

const columns: ColumnDef[] = [
  { key: 'fp_code', label: 'FP Code', type: 'text' },
  { key: 'franchise_name', label: 'Franchise Name', type: 'text' },
  { key: 'fp_status', label: 'FP Status', type: 'text' },
  { key: 'last_sync_at', label: 'Data Age', type: 'sync_status' },
  { key: 'start_date', label: 'Start Date', type: 'date' },
  { key: 'country', label: 'Country', type: 'text' },
  { key: 'region_code', label: 'Region', type: 'text' },
  { key: 'account_code', label: 'Account Code', type: 'text' },
  { key: 'account_name', label: 'Account Name', type: 'text' },
  { key: 'account_type', label: 'Account Type', type: 'text' },
  { key: 'account_class', label: 'Account Class', type: 'text' },
  { key: 'account_tax_type', label: 'Tax Type', type: 'text' },
  { key: 'balance', label: 'Balance', type: 'currency' },
  { key: 'master_name', label: 'Master Name', type: 'text' },
  { key: 'master_type', label: 'Master Type', type: 'text' },
  { key: 'master_class', label: 'Master Class', type: 'text' },
  { key: 'master_tax_type', label: 'Master Tax Type', type: 'text' },
  { key: 'report_date', label: 'Report Date', type: 'date' },
]

const columnGroups: ColumnGroup[] = [
  { label: null, columnKeys: ['fp_code', 'franchise_name', 'fp_status', 'last_sync_at'] },
  { label: null, columnKeys: ['start_date', 'country', 'region_code'] },
  { label: 'FP Account', columnKeys: ['account_code', 'account_name', 'account_type', 'account_class', 'account_tax_type', 'balance'] },
  { label: 'Master COA', columnKeys: ['master_name', 'master_type', 'master_class', 'master_tax_type'] },
  { label: null, columnKeys: ['report_date'] },
]

export default function XeroTrialBalanceReport() {
  return (
    <BaseReportPage
      reportType="xero_trial_balance"
      title="Xero Trial Balance"
      description="Combined trial balance and COA alignment report from Xero"
      filterConfig={{
        showFpSelector: true,
        showFpStatus: true,
        showCountry: true,
        showRegion: true,
        showMonthEndPicker: true,
        defaultMonthEnd: 'previous_month',
        monthEndAfterFilter: 'fpStatus',
        linkFpStatusToSearch: true,
      }}
      columns={columns}
      columnGroups={columnGroups}
      defaultSortColumn="fp_code"
    />
  )
}
